(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7972],{

/***/ 3812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ SiteTicker_SiteTicker; },
  "d": function() { return /* reexport */ SiteTicker_SiteTickerWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-fast-marquee@1.3.5_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(67399);
// EXTERNAL MODULE: ./components/providers/SiteTickerProvider.tsx
var SiteTickerProvider = __webpack_require__(79771);
// EXTERNAL MODULE: ./components/cms/Theme/index.tsx + 2 modules
var Theme = __webpack_require__(61625);
// EXTERNAL MODULE: ./components/cms/SiteTicker/SiteTicker.module.scss
var SiteTicker_module = __webpack_require__(38841);
var SiteTicker_module_default = /*#__PURE__*/__webpack_require__.n(SiteTicker_module);
;// CONCATENATED MODULE: ./components/cms/SiteTicker/SiteTicker.tsx






var SiteTicker = function(param) {
    var children = param.children, foregroundColor = param.foregroundColor, backgroundColor = param.backgroundColor;
    var ref = (0,SiteTickerProvider/* useSiteTicker */.aV)(), showTicker = ref.showTicker, hideTicker = ref.hideTicker;
    var tickerHidden = showTicker === "false";
    if (tickerHidden) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Theme/* default */.Z, {
            colorBackground: backgroundColor.color,
            colorPrimary: foregroundColor.color,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SiteTicker_module_default()).siteticker,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SiteTicker_module_default()).siteticker__inner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SiteTicker_module_default()).siteticker__innerColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                gradient: false,
                                speed: 40,
                                pauseOnHover: true,
                                children: children
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return hideTicker();
                                },
                                className: (SiteTicker_module_default()).tickerClose,
                                children: "\u274C"
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var SiteTicker_SiteTicker = (SiteTicker);

// EXTERNAL MODULE: ./storyblok/components/DynamicComponent.tsx + 1 modules
var DynamicComponent = __webpack_require__(79426);
;// CONCATENATED MODULE: ./components/cms/SiteTicker/SiteTickerWrapper.tsx



var SiteTickerWrapper = function(param) {
    var storyContent = param.storyContent;
    var ref, ref1;
    // Strip out the Text components from globalHeader story
    var headerTapeTickerText = storyContent === null || storyContent === void 0 ? void 0 : (ref = storyContent.globalHeader) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.content.filter(function(blok) {
        return blok.component === "SiteTicker";
    });
    if (!headerTapeTickerText || headerTapeTickerText.length < 1) {
        return null;
    }
    // @todo - style as required
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: headerTapeTickerText.map(function(headerTapeTickerTextContent) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponent/* default */.Z, {
                    blok: headerTapeTickerTextContent
                }, headerTapeTickerTextContent._uid)
            }, headerTapeTickerTextContent._uid);
        })
    });
};
/* harmony default export */ var SiteTicker_SiteTickerWrapper = (SiteTickerWrapper);

;// CONCATENATED MODULE: ./components/cms/SiteTicker/index.ts





/***/ }),

/***/ 61625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cms_Theme; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./lib/isLightColor.ts
// How to determine if color is dark/light https://stackoverflow.com/a/51567564
var isLightColor = function(color) {
    var hex = color.replace("#", "");
    var r = parseInt(hex.substring(0, 0 + 2), 16);
    var g = parseInt(hex.substring(2, 2 + 2), 16);
    var b = parseInt(hex.substring(4, 4 + 2), 16);
    var brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155;
};

;// CONCATENATED MODULE: ./components/cms/Theme/Theme.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var Theme = function(param) {
    var children = param.children, variant = param.variant, as = param.as, applyBackground = param.applyBackground, colorBackground = param.colorBackground, colorPrimary = param.colorPrimary;
    var themeRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isLightBackground = ref[0], setIsLightBackground = ref[1];
    var Tag = as || "div";
    var style = _objectSpread({}, applyBackground && {
        backgroundColor: "var(--color-background)"
    });
    if (colorBackground) style["--color-background"] = colorBackground;
    if (colorPrimary) style["--color-primary"] = colorPrimary;
    if (!isLightBackground) style["--theme-override-color"] = "var(--white)";
    (0,react.useEffect)(function() {
        if (themeRef.current) {
            var styles = window.getComputedStyle(themeRef.current);
            var color = styles.getPropertyValue("--color-background"); // get current color background
            setIsLightBackground(isLightColor(color));
        }
    }, [
        themeRef,
        colorBackground
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        style: style,
        className: "th-".concat(variant),
        ref: themeRef,
        children: children
    });
};
/* harmony default export */ var Theme_Theme = (Theme);

;// CONCATENATED MODULE: ./components/cms/Theme/index.tsx

/* harmony default export */ var cms_Theme = (Theme_Theme);


/***/ }),

/***/ 6695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ global_Footer; }
});

// UNUSED EXPORTS: FooterLinks, FooterSocial

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
// EXTERNAL MODULE: ./lib/hooks/randomNumber.ts
var randomNumber = __webpack_require__(79245);
// EXTERNAL MODULE: ./components/global/Link/index.tsx + 1 modules
var Link = __webpack_require__(84381);
// EXTERNAL MODULE: ./components/global/Toast/index.tsx + 16 modules
var Toast = __webpack_require__(81530);
// EXTERNAL MODULE: ./components/global/Footer/Footer.module.scss
var Footer_module = __webpack_require__(41450);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
;// CONCATENATED MODULE: ./components/global/Footer/FooterLinks.tsx



var FooterLinks = function(param1) {
    var links = param1.links;
    if (!links || links.length < 1) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (Footer_module_default()).footerLinksContainer,
        children: [
            links.map(function(param) {
                var slug = param.slug, name = param.name;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/".concat(slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: [
                                (Footer_module_default()).footerLink,
                                "u-h6"
                            ].join(" "),
                            children: name
                        })
                    })
                }, slug);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {})
        ]
    });
};
/* harmony default export */ var Footer_FooterLinks = (FooterLinks);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.34.2_react@18.0.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(67128);
// EXTERNAL MODULE: ./lib/ga.tsx
var ga = __webpack_require__(7587);
// EXTERNAL MODULE: ./lib/util.tsx + 1 modules
var util = __webpack_require__(70108);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Checkbox/index.tsx
var Checkbox = __webpack_require__(98188);
;// CONCATENATED MODULE: ./components/global/Footer/FooterSocial.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var FooterSocial = function(param) {
    var instagram = param.instagram, twitter = param.twitter, pinterest = param.pinterest, setSubscriptionMessage = param.setSubscriptionMessage;
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "onChange"
    }), register = ref.register, handleSubmit = ref.handleSubmit, isValid = ref.formState.isValid, resetField = ref.resetField, getValues = ref.getValues, watch = ref.watch;
    watch("email");
    var email1 = getValues("email");
    watch("email");
    var handleSubscribe = handleSubmit(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var email, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = data.email;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetch("".concat("https://theentente.createsend.com/t/r/s/zidjy/?callback=JSON_CALLBACK&cm-zidjy-zidjy=").concat(email), {
                            method: "POST"
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.status === 200) {
                            setSubscriptionMessage("Thank you for subscribing to our newsletter");
                            (0,ga/* sendEventGA */.Z)("send", "pageview", {
                                page: "/newsletter-signup/"
                            });
                        } else {
                            setSubscriptionMessage("Fail!");
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        setSubscriptionMessage("Fail!");
                    case 11:
                        resetField("email");
                        resetField("acceptPolicy");
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (0,clsx_m/* default */.Z)((Footer_module_default()).socialContainer, "u-h6"),
                children: [
                    instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (Footer_module_default()).social,
                            href: instagram,
                            rel: "noopener noreferrer",
                            target: "_blank",
                            "aria-label": "Instagram",
                            children: "Instagram"
                        })
                    }),
                    twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (Footer_module_default()).lastLi,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (Footer_module_default()).social,
                            href: twitter,
                            rel: "noopener noreferrer",
                            target: "_blank",
                            "aria-label": "Twitter",
                            children: "Twitter"
                        })
                    }),
                    pinterest && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (Footer_module_default()).lastLi,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (Footer_module_default()).social,
                            href: pinterest,
                            rel: "noopener noreferrer",
                            target: "_blank",
                            "aria-label": "Twitter",
                            children: "Pinterest"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((Footer_module_default()).newsletter, "u-h6"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)((Footer_module_default()).social, (Footer_module_default()).newsletterText),
                        children: "Newsletter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (Footer_module_default()).newsletterForm,
                        onSubmit: handleSubscribe,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_module_default()).newsletterFormContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                        type: "email",
                                        "aria-label": "email",
                                        className: (Footer_module_default()).newsletterInput,
                                        placeholder: "mail@website.com"
                                    }, register("email", _objectSpread({
                                        required: true
                                    }, util/* inputFieldValidation.emailFormat */.cU.emailFormat)))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: (Footer_module_default()).newsletterSubmit,
                                        disabled: !isValid,
                                        children: "Subscribe"
                                    })
                                ]
                            }),
                            email1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_module_default()).acceptPolicy,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, _objectSpread({
                                        name: "acceptPolicy",
                                        value: "Yes",
                                        id: "acceptPolicy",
                                        label: "Accept Colophon Foundry Privacy Policy.",
                                        subLabel: "",
                                        isSmall: true,
                                        hideLabel: true
                                    }, register("acceptPolicy", {
                                        required: true
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (Footer_module_default()).acceptPolicy__text,
                                        children: [
                                            "I've read and accept the",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/privacy-policy",
                                                label: "Colophon Foundry Privacy Policy.",
                                                className: (Footer_module_default()).acceptPolicy__link
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_FooterSocial = (FooterSocial);

;// CONCATENATED MODULE: ./components/global/Footer/phrases.ts
var footerPhrases = [
    "Welcome to Paradise",
    "Your Business is Greatly Appreciated",
    "Have a Very Pleasant Day",
    "Premium Service on all Font Deliveries!",
    "Don\u2019t Worry, it\u2019s OK",
    "Born to B\xe9zier",
    "Our Fonts Are Your Fonts",
    "Buy 1, Buy All",
    "Our Way or the B\xe9zier",
    "In B\xe9ziers We Trust",
    "Infinite Blessings!",
    "Buy Fonts and Live Forever",
    "Your Satisfaction is our Priority",
    "The Shop & The Service",
    "Young or Old, We Treat You Like Solid Gold",
    "The Local Flagship Store",
    "Open 24 / 7 / 365",
    "Choose, Buy and Download",
    "Future Investments",
    "Autonomous Collective",
    "Independent Together",
    "Cultural Instructions",
    "Open From: 00:01 \u2014 23:59",
    "Why Rush? Stay and Browse!",
    "Open Every Night",
    "Fonts, Fonts, Fonts! It\u2019s OK to Repeat",
    "Hi! Hey! Hello!",
    "Buy Low, Sell High!",
    "General Public Welcome",
    "Hours of Fun",
    "A Message That's Familiar!",
    "United Kingdom, Europe, and the World",
    "Open Until Further Notice",
    "I Love the Typeface xoxo",
    "Fonts. Now Available Very Very Fast",
    "Art This Way \u2192",
    "Serves You Right",
    "Does it Come in Black?",
    "You\u2019re in Safe Hands",
    "This Website is from the Internet \u2014 Check that it is Genuine",
    "Serves Not Only Fonts, But Dreams",
    "World Wide Quality",
    "Let\u2019s Do This!",
    "Free Collection & Delivery",
    "Your Trusted Partners in Typography",
    "You Will Be Delighted!",
    "Special Presentation",
    "No Freebies Here!",
    "Direct from the manufacturer!",
    "Fixed & Fair Prices!",
    "If We Don\u2019t Have It, You Don\u2019t Need It",
    "Kaizen! Kaizen! Kaizen!",
    "Extra Quality",
    "Delivery 120% to Patrons",
    "Necessarily Completely Necessary",
    "The know-how of knowing how to know",
    "Who wants to buy the past? Buy the future"
];

;// CONCATENATED MODULE: ./components/global/Footer/Footer.tsx












var footerDate = new Date().getFullYear();
var Footer = function(param) {
    var navigation = param.navigation, _theme = param.theme, theme = _theme === void 0 ? "" : _theme;
    var ref = (0,react.useState)(""), subscriptionMessage = ref[0], setSubscriptionMessage = ref[1];
    var ref1 = (0,react.useState)(""), footerPhrase = ref1[0], setFooterPhrase = ref1[1];
    var randomMessageNumber = (0,randomNumber/* useRandomNumber */.H)(footerPhrases.length);
    (0,react.useEffect)(function() {
        var randomMessage = function() {
            var i = randomMessageNumber;
            return footerPhrases[i];
        };
        setFooterPhrase(randomMessage());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(theme && (Footer_module_default())["footer-".concat(theme)], !theme && (Footer_module_default())["footer-normal"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
            as: "footer",
            className: (Footer_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                    sm: 12,
                    md: 12,
                    lg: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                    sm: 12,
                    md: 6,
                    lg: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "Footer navigation",
                        children: navigation.map(function(navArray, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterLinks, {
                                links: navArray
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                    sm: 12,
                    md: 6,
                    lg: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterSocial, {
                        facebook: constants/* SOCIAL_FACEBOOK_ID */.js,
                        instagram: constants/* SOCIAL_INSTAGRAM_ID */.ag,
                        twitter: constants/* SOCIAL_TWITTER_ID */.R1,
                        pinterest: constants/* SOCIAL_PINTEREST_ID */.V3,
                        subscriptionMessage: subscriptionMessage,
                        setSubscriptionMessage: setSubscriptionMessage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Column */.s, {
                    sm: 12,
                    md: 12,
                    lg: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).footerSupport,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "u-h5",
                                children: [
                                    "We are here for you ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (Footer_module_default()).mailTo,
                                        href: "https://www.monotype.com/colophon-speak-sales",
                                        children: "Contact Us"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: (Footer_module_default()).hrSmall
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                    sm: 12,
                    md: 0,
                    lg: 0,
                    xl: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer_module_default()).mobileTagline,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: footerPhrase
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                    sm: 12,
                    md: 12,
                    lg: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).subFooter,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Footer_module_default()).subFooterCopy,
                                children: [
                                    "\xa9 ",
                                    "".concat(footerDate, " Monotype Imaging Inc.")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Footer_module_default()).subFooterTagline,
                                children: footerPhrase
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Footer_module_default()).subFooterNav,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        className: (Footer_module_default()).subFooterTerms,
                                        href: "https://www.monotype.com/legal/privacy-policy",
                                        label: "Privacy Policy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        className: (Footer_module_default()).subFooterTerms,
                                        href: "https://www.monotype.com/legal/terms-use",
                                        label: "Terms of Service"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                subscriptionMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* default */.ZP, {
                    message: subscriptionMessage,
                    onClose: function() {
                        return setSubscriptionMessage("");
                    },
                    className: (Footer_module_default()).subscriptionToast,
                    autoClose: true,
                    autoCloseTime: 5000
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./components/global/Footer/index.ts



/* harmony default export */ var global_Footer = (Footer_Footer);



/***/ }),

/***/ 50794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Header; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/focus-trap-react@8.11.3_xw2k5ke7c4fkuho3lbp7joprty/node_modules/focus-trap-react/dist/focus-trap-react.js
var focus_trap_react = __webpack_require__(29876);
var focus_trap_react_default = /*#__PURE__*/__webpack_require__.n(focus_trap_react);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/cms/SiteTicker/index.ts + 2 modules
var SiteTicker = __webpack_require__(3812);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/providers/TypefaceMenuProvider.tsx
var TypefaceMenuProvider = __webpack_require__(24082);
// EXTERNAL MODULE: ./components/providers/TypefaceProvider.tsx
var TypefaceProvider = __webpack_require__(49717);
// EXTERNAL MODULE: ./components/global/Dropdown/index.tsx + 3 modules
var Dropdown = __webpack_require__(58677);
// EXTERNAL MODULE: ./components/global/Icon/defaultIconSizes.tsx
var defaultIconSizes = __webpack_require__(57556);
// EXTERNAL MODULE: ./components/global/Breadcrumbs/Breadbrumbs.module.scss
var Breadbrumbs_module = __webpack_require__(58152);
var Breadbrumbs_module_default = /*#__PURE__*/__webpack_require__.n(Breadbrumbs_module);
;// CONCATENATED MODULE: ./components/global/Breadcrumbs/Breadcrumbs.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var BreadbrumbDropdownMenu = function(param) {
    var overviewLink = param.overviewLink, pageSlug = param.pageSlug;
    var items = (0,TypefaceMenuProvider/* useTypefaceMenu */.hj)().items;
    var activePage = items.find(function(item) {
        return item.href === pageSlug;
    });
    if (activePage) {
        activePage = {
            url: activePage.href,
            name: activePage.text
        };
    } else {
        activePage = overviewLink;
    }
    var dropdownItems = items.filter(function(item) {
        return item.href !== activePage.url;
    }).map(function(item) {
        return {
            name: item.text,
            url: item.href
        };
    });
    // Add overview link if it's not the active page
    if (pageSlug !== overviewLink.url && !dropdownItems.includes(overviewLink)) {
        dropdownItems.unshift(overviewLink);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
        fullWidth: true,
        items: dropdownItems,
        defaultValue: activePage
    });
};
var BreadcrumbArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Breadbrumbs_module_default()).arrowDesktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, _objectSpread({
                    iconName: "arrow-right",
                    color: "var(--header-color)"
                }, defaultIconSizes/* DEFAULT_ARROW_ICON_SIZES */.G), "breadcrumb-arrow-desktop")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Breadbrumbs_module_default()).arrowMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, _objectSpread({
                    iconName: "arrow-right",
                    color: "var(--header-color)"
                }, defaultIconSizes/* DEFAULT_ARROW_ICON_SIZES */.G), "breadcrumb-arrow-mobile")
            })
        ]
    });
};
var Breadcrumbs = function(param) {
    var pageName = param.pageName, onTypefacePage = param.onTypefacePage, _hideBuyNow = param.hideBuyNow, hideBuyNow = _hideBuyNow === void 0 ? false : _hideBuyNow, _renderParentOnly = param.renderParentOnly, renderParentOnly = _renderParentOnly === void 0 ? false : _renderParentOnly;
    var ref = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)(), setConfiguratorVisible = ref.setIsOpen, typefaceState = ref.state;
    var configuratorVisible = typefaceState.isOpen;
    var ref1 = (0,react.useState)(""), windowSlug = ref1[0], setWindowSlug = ref1[1];
    var router = (0,next_router.useRouter)();
    var typefaceRoot = router.asPath.split("/").slice(0, 3).join("/");
    var overviewLink = {
        url: typefaceRoot,
        name: "Overview"
    };
    (0,react.useEffect)(function() {
        var pageSlug = window.location.pathname;
        setWindowSlug(pageSlug);
    }, []);
    var breadcrumbs = (0,react.useMemo)(function generateBreadcrumbs() {
        var asPathWithoutQuery = router.asPath.split("?")[0];
        var asPathNestedRoutes = asPathWithoutQuery.split("/").filter(function(v) {
            return v.length > 0;
        });
        var crumbsListData = function(crumbs) {
            return crumbs.map(function(subpath, idx) {
                var href = "/" + asPathNestedRoutes.slice(0, idx + 1).join("/");
                // the pageName override is only for the page the user is browsing
                // if we need in future to manually control page names for all the breadcrumbs
                // we'll need a much better solution
                var pageSlug = windowSlug.split("/");
                var pageDisplayName = subpath === (pageSlug === null || pageSlug === void 0 // get the current page slug
                 ? void 0 : pageSlug[pageSlug.length - 1]) ? pageName || subpath.replace("-", " ") : subpath.replaceAll("-", " ");
                // Always use pageName for parent only crumbs
                if (renderParentOnly) {
                    pageDisplayName = pageName;
                }
                return {
                    href: href,
                    name: pageDisplayName
                };
            });
        };
        var topLevelCrumblist = crumbsListData(asPathNestedRoutes.slice(0, 2));
        return topLevelCrumblist;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.asPath,
        windowSlug
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Breadbrumbs_module_default()).breadcrumbs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: !renderParentOnly ? breadcrumbs.map(function(crumb, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Breadbrumbs_module_default()).breadcrumbs__link,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: crumb.href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,clsx_m/* default */.Z)("u-h6", (Breadbrumbs_module_default()).name),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: crumb.name
                                        })
                                    })
                                }),
                                index < breadcrumbs.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbArrow, {})
                            ]
                        })
                    }, crumb.href);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Breadbrumbs_module_default()).breadcrumbs__link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: breadcrumbs[0].href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (0,clsx_m/* default */.Z)("u-h6", (Breadbrumbs_module_default()).name),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: breadcrumbs[0].name
                                })
                            })
                        })
                    })
                }, breadcrumbs[0].href)
            }),
            !hideBuyNow && onTypefacePage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Breadbrumbs_module_default()).dropdownMenu,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbArrow, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadbrumbDropdownMenu, {
                        overviewLink: overviewLink,
                        pageSlug: windowSlug
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "l",
                        callBack: function() {
                            setConfiguratorVisible(!configuratorVisible);
                        },
                        "data-cy": "breadcrumb-buy-now",
                        children: "Buy Now"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./components/global/Breadcrumbs/index.tsx

/* harmony default export */ var global_Breadcrumbs = (Breadcrumbs_Breadcrumbs);

// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(42623);
// EXTERNAL MODULE: ./components/global/Header/HeaderPanel.module.scss
var HeaderPanel_module = __webpack_require__(87820);
var HeaderPanel_module_default = /*#__PURE__*/__webpack_require__.n(HeaderPanel_module);
// EXTERNAL MODULE: ./components/providers/CheckoutProvider.tsx + 2 modules
var CheckoutProvider = __webpack_require__(34639);
// EXTERNAL MODULE: ./components/providers/HeaderThemeProvider.tsx
var HeaderThemeProvider = __webpack_require__(13657);
// EXTERNAL MODULE: ./lib/auth/index.ts + 1 modules
var auth = __webpack_require__(9714);
// EXTERNAL MODULE: ./lib/hooks/useUser.ts
var useUser = __webpack_require__(56804);
// EXTERNAL MODULE: ./lib/paths.ts + 1 modules
var lib_paths = __webpack_require__(47475);
// EXTERNAL MODULE: ./components/global/Menu/Menu.module.scss
var Menu_module = __webpack_require__(24962);
var Menu_module_default = /*#__PURE__*/__webpack_require__.n(Menu_module);
;// CONCATENATED MODULE: ./components/global/Menu/Menu.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













var Menu = function(param) {
    var menuIsOpen = param.menuIsOpen, navigation = param.navigation;
    var authenticated = (0,useUser/* useUser */.a)().authenticated;
    var signOut = (0,auth/* useSaleorAuthContext */.ex)().signOut;
    var resetCheckoutToken = (0,CheckoutProvider/* useCheckout */.Mg)().resetCheckoutToken;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var router = (0,next_router.useRouter)();
    var paths = (0,lib_paths/* usePaths */._)();
    var setMenuOpen = (0,HeaderThemeProvider/* useHeaderTheme */.BL)().setMenuOpen;
    var Navigation = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (Menu_module_default()).menu,
            children: navigation && navigation.map(function(link, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (Menu_module_default()).topMenu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: link.slug ? "/".concat(link.slug) : "#",
                        as: link.slug ? "/".concat(link.slug) : "#",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: link.name,
                            children: link.name
                        })
                    })
                }, i);
            })
        });
    };
    var onLogout = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return signOut();
                    case 2:
                        _ctx.next = 4;
                        return resetCheckoutToken();
                    case 4:
                        _ctx.next = 6;
                        return client.resetStore();
                    case 6:
                        setMenuOpen(false);
                        router.push({
                            pathname: "/",
                            query: {
                                logout: 1
                            }
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((HeaderPanel_module_default()).headerPanel, " ").concat((Menu_module_default()).mobileMenu, " u-desktop-hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeaderPanel_module_default()).headerPanel__inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Menu_module_default()).mobileMenu__bottomContent,
                        children: [
                            authenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (Menu_module_default()).logoutButton,
                                callBack: onLogout,
                                children: "Log out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Menu_module_default()).support,
                                children: [
                                    "We are here for you ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.monotype.com/colophon-speak-sales",
                                        children: "Contact Us"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (Menu_module_default()).mobileMenu__bottomMenu,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            href: "https://www.monotype.com/legal/terms-use",
                                            children: "Terms of Service"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            href: "https://www.monotype.com/legal/privacy-policy",
                                            children: "Privacy Policy"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Menu_Menu = (Menu);

;// CONCATENATED MODULE: ./components/global/Menu/index.tsx

/* harmony default export */ var global_Menu = (Menu_Menu);

// EXTERNAL MODULE: ./lib/datalayer/checkout.ts
var datalayer_checkout = __webpack_require__(74198);
// EXTERNAL MODULE: ./lib/hooks/mediaQuery.ts
var mediaQuery = __webpack_require__(99182);
// EXTERNAL MODULE: ./components/global/Header/Header.module.scss
var Header_module = __webpack_require__(6474);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./components/global/Header/partials/LogoLabel.tsx

var LogoLabel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "111",
        height: "15",
        viewBox: "0 0 111 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M101.221 14.4712V3.69353C101.341 3.99451 101.819 4.79121 101.819 4.79121L108.073 14.4712H110.281V0.528846H108.188V11.2666C108.068 10.9657 107.59 10.169 107.59 10.169L101.341 0.528846H99.132V14.4712H101.221ZM89.9699 12.7804C87.2611 12.7804 85.1897 10.7488 85.1897 7.50443C85.1897 4.26007 87.2611 2.20635 89.9699 2.20635C92.6787 2.20635 94.7723 4.26007 94.7723 7.50443C94.7723 10.7488 92.7009 12.7804 89.9699 12.7804ZM89.9699 14.75C93.9357 14.75 96.9411 11.7402 96.9411 7.5C96.9411 3.25977 93.9313 0.25 89.9699 0.25C86.0085 0.25 83.0165 3.23764 83.0165 7.5C83.0165 11.7624 86.0218 14.75 89.9699 14.75ZM72.0839 14.4712V8.33654H78.6789V14.4712H80.83V0.528846H78.6789V6.36691H72.0839V0.528846H69.9328V14.4712H72.0839ZM58.8011 2.44093H62.6651C64.6746 2.44093 65.6351 3.41468 65.6351 4.97268C65.6351 6.53068 64.679 7.52213 62.6651 7.52213H58.8011V2.44093ZM58.8011 14.4712V9.42979H62.7227C65.79 9.42979 67.7817 7.79655 67.7817 4.96825C67.7817 2.13996 65.79 0.52442 62.7227 0.52442H56.65V14.4667H58.8011V14.4712ZM47.4879 12.7804C44.7791 12.7804 42.7077 10.7488 42.7077 7.50443C42.7077 4.26007 44.7791 2.20635 47.4879 2.20635C50.1967 2.20635 52.2903 4.26007 52.2903 7.50443C52.2903 10.7488 50.2189 12.7804 47.4879 12.7804ZM47.4879 14.75C51.4538 14.75 54.4591 11.7402 54.4591 7.5C54.4591 3.25977 51.4493 0.25 47.4835 0.25C43.5177 0.25 40.5345 3.23764 40.5345 7.5C40.5345 11.7624 43.5398 14.75 47.4835 14.75M40.0963 14.4712V12.4971H33.0455V0.528846H30.8944V14.4712H40.0963ZM21.7323 12.7804C19.0235 12.7804 16.9521 10.7488 16.9521 7.50443C16.9521 4.26007 19.0235 2.20635 21.7323 2.20635C24.4411 2.20635 26.5346 4.26007 26.5346 7.50443C26.5346 10.7488 24.4632 12.7804 21.7323 12.7804ZM21.7323 14.75C25.6981 14.75 28.7034 11.7402 28.7034 7.5C28.7034 3.25977 25.6937 0.25 21.7323 0.25C17.7709 0.25 14.7788 3.23764 14.7788 7.5C14.7788 11.7624 17.7842 14.75 21.7323 14.75ZM6.95345 14.75C9.96322 14.75 11.5566 13.4753 13.0704 11.0675L11.415 9.87241C10.3793 11.8243 8.9275 12.7804 6.97558 12.7804C4.24908 12.7804 2.17323 10.5717 2.17323 7.50443C2.17323 4.43712 4.35974 2.20192 6.99328 2.20192C8.96291 2.20192 10.3173 3.11813 11.2955 5.08776L13.0305 3.85287C12.0523 1.7239 9.87912 0.25 7.05082 0.25C3.12485 0.25 0 3.23764 0 7.5C0 11.7624 2.9478 14.75 6.94902 14.75",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ var partials_LogoLabel = ((/* unused pure expression or super */ null && (LogoLabel)));

;// CONCATENATED MODULE: ./components/global/Header/partials/index.ts


;// CONCATENATED MODULE: ./components/global/Header/Header.tsx
function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




















var Header = function(param) {
    var navigation = param.navigation, headerTheme = param.headerTheme, hasBorder = param.hasBorder, pageName = param.pageName, _showNavigation = param.showNavigation, showNavigation = _showNavigation === void 0 ? true : _showNavigation, onTypefacePage = param.onTypefacePage, _isMaintenance = param.isMaintenance, isMaintenance = _isMaintenance === void 0 ? false : _isMaintenance, _renderParentOnly = param.renderParentOnly, renderParentOnly = _renderParentOnly === void 0 ? false : _renderParentOnly, blok = param.blok;
    var ref, ref1, ref2;
    var headerThemeSet = headerTheme || "default";
    var headerRef = (0,react.useRef)();
    var paths = (0,lib_paths/* usePaths */._)();
    var router = (0,next_router.useRouter)();
    var screenSize = (0,mediaQuery/* useScreenSize */.e)();
    var topLevelNavLinks = navigation === null || navigation === void 0 ? void 0 : (ref = navigation.headerLinks) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.filter(function(navItem) {
        return navItem.parentId === 0;
    });
    var checkout = (0,CheckoutProvider/* useCheckout */.Mg)().checkout;
    var ref3 = (0,HeaderThemeProvider/* useHeaderTheme */.BL)(), headerState = ref3.headerState, setMenuOpen = ref3.setMenuOpen, headerClasses = ref3.headerClasses, setHeaderTheme = ref3.setHeaderTheme;
    var menuIsOpen = headerState.menuOpen;
    var headerIsFixed = headerState.fixed;
    var toggleMenu = function() {
        setMenuOpen(!menuIsOpen);
    };
    var authenticated = (0,useUser/* useUser */.a)().authenticated;
    (0,react.useEffect)(function() {
        var setMenuAsOpen = function() {
            setMenuOpen(false);
        };
        router.events.on("routeChangeStart", setMenuAsOpen);
        return function() {
            router.events.off("routeChangeStart", setMenuAsOpen);
        };
    }, []);
    // Sync page header theme with state
    (0,react.useEffect)(function() {
        setHeaderTheme(headerThemeSet);
    }, []);
    (0,react.useEffect)(function() {
        setHeaderTheme(headerThemeSet);
    }, [
        headerThemeSet
    ]);
    var counter = (checkout === null || checkout === void 0 ? void 0 : (ref2 = checkout.lines) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(amount, line) {
        return line ? amount + line.quantity : amount;
    }, 0)) || 0;
    var focusTrapOptions = {
        allowOutsideClick: true
    };
    var onHome = router.asPath === "/" || router.pathname === "/404" || router.pathname === "/maintenance";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "skip-to-content-link",
                href: "#main",
                children: "Skip to content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                ref: headerRef,
                className: headerClasses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).header__content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteTicker/* SiteTickerWrapper */.d, {
                            storyContent: blok
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                        rowAlign: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                sm: 8,
                                md: 9,
                                lg: onHome ? 9 : 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: [
                                        (Header_module_default()).logoNav,
                                        menuIsOpen ? (Header_module_default()).logoNav_menuIsOpen : ""
                                    ].join(" "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: isMaintenance ? "/maintenance" : "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: (Header_module_default()).logo,
                                                title: "Colophon",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        iconName: "logo-small",
                                                        color: "var(--header-color)",
                                                        width: "18",
                                                        height: "23"
                                                    }),
                                                    onHome ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((Header_module_default()).logoLabel, " u-h5"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLabel, {})
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        !onHome ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Header_module_default()).breadcrumbArrow,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, Header_objectSpread({
                                                iconName: "arrow-right",
                                                color: "var(--header-color)"
                                            }, defaultIconSizes/* DEFAULT_ARROW_ICON_SIZES */.G))
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Header_module_default()).breadcrumbMobile,
                                            children: !onHome && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Breadcrumbs, {
                                                pageName: pageName,
                                                onTypefacePage: onTypefacePage,
                                                hideBuyNow: true
                                            })
                                        })
                                    ]
                                })
                            }),
                            !onHome && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                sm: 0,
                                md: 0,
                                lg: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Header_module_default()).breadcrumbDesktop,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Breadcrumbs, {
                                        pageName: pageName,
                                        onTypefacePage: onTypefacePage
                                    })
                                })
                            }),
                            showNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                sm: 4,
                                md: 3,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    role: "navigation",
                                    "aria-label": "Site Menu",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Header_module_default()).navtopIcons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Header_module_default()).topIcon,
                                                children: [
                                                    !authenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        href: paths.account.login.$url(),
                                                        variant: "ghost",
                                                        title: "Login to Account",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            iconName: "account",
                                                            color: "var(--header-icon-color)"
                                                        })
                                                    }),
                                                    authenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        href: paths.account.$url(),
                                                        variant: "ghost",
                                                        title: "View Account",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            iconName: "account",
                                                            color: "var(--header-icon-color)"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Header_module_default()).topIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                    // add 'view_cart' to the dataLayer
                                                    callBack: function() {
                                                        datalayer_checkout/* default.viewCart */.Z.viewCart((checkout === null || checkout === void 0 ? void 0 : checkout.lines) || []);
                                                    },
                                                    href: paths.cart.$url(),
                                                    variant: "ghost",
                                                    title: "Open Cart",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            iconName: "cart",
                                                            color: "var(--header-icon-color)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (Header_module_default()).basketCount,
                                                            children: counter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((focus_trap_react_default()), {
                                                active: menuIsOpen,
                                                focusTrapOptions: focusTrapOptions,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Header_module_default()).topIcon,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            callBack: toggleMenu,
                                                            variant: "ghost",
                                                            title: "".concat(menuIsOpen ? "Close Menu" : "Open Menu"),
                                                            "aria-expanded": menuIsOpen,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                iconName: menuIsOpen ? "close" : "burger",
                                                                color: "var(--header-icon-color)"
                                                            })
                                                        }),
                                                        screenSize !== "Mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                            fallback: null,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Menu, {
                                                                menuIsOpen: menuIsOpen,
                                                                navigation: topLevelNavLinks
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            hasBorder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Header_module_default()).headerBorder,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            screenSize === "Mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Menu, {
                    menuIsOpen: menuIsOpen,
                    navigation: topLevelNavLinks
                })
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./components/global/Header/index.tsx

/* harmony default export */ var global_Header = (Header_Header);


/***/ }),

/***/ 84381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Link; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
;// CONCATENATED MODULE: ./components/global/Link/Link.tsx


var Link = function(param) {
    var href = param.href, label = param.label, className = param.className, locale = param.locale;
    //check if url is external link
    var re = new RegExp("^(http|https)://", "i");
    var match = re.test(href);
    return !match ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        locale: locale,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: className,
            children: label
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        className: className,
        target: "_blank",
        rel: "noopener noreferrer",
        children: label
    });
};
/* harmony default export */ var Link_Link = (Link);

;// CONCATENATED MODULE: ./components/global/Link/index.tsx

/* harmony default export */ var global_Link = (Link_Link);


/***/ }),

/***/ 24082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hj": function() { return /* binding */ useTypefaceMenu; },
/* harmony export */   "Fc": function() { return /* binding */ TypefaceMenuProvider; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _lib_useSafeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95841);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var ref = _slicedToArray((0,_lib_useSafeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), 2);
var useTypefaceMenu = ref[0], Provider = ref[1];
var TypefaceMenuProvider = function(param) {
    var children = param.children, items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: {
            items: items
        },
        children: children
    });
};


/***/ }),

/***/ 7587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ sendEventGA; }
/* harmony export */ });
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52375);

var sendEventGA = function(event, action, data) {
    if (_lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .GA_4_TRACKING_ID */ .AC) {
        //@ts-expect-error
        window.gtag(event, action, data);
    }
};


/***/ }),

/***/ 79245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useRandomNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85170);

function useRandomNumber(multiplier) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Math.floor(Math.random() * multiplier)), randomNumber = ref[0], setRandomNumber = ref[1];
    return randomNumber;
}


/***/ }),

/***/ 83176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getStoryBlokNavLinks; }
/* harmony export */ });
var getNavigations = function(navigation) {
    var _links = navigation.links, links = _links === void 0 ? [] : _links;
    return links.map(function(link) {
        var haveData = link.Link.cached_url && link.LinkName;
        return haveData ? {
            slug: link.Link.cached_url,
            name: link.LinkName,
            parentId: 0
        } : null;
    }).filter(function(item) {
        return item !== null && item.parentId === 0;
    });
};
function getStoryBlokNavLinks(story) {
    var ref, ref1;
    if (!story) {
        return {
            headerLinks: [],
            footerLinks: []
        };
    }
    var content = story.content;
    var globalHeader = content.globalHeader, globalFooter = content.globalFooter;
    var headerGlobal = (globalHeader === null || globalHeader === void 0 ? void 0 : (ref = globalHeader.content) === null || ref === void 0 ? void 0 : ref.content) || [];
    var footerGlobal = (globalFooter === null || globalFooter === void 0 ? void 0 : (ref1 = globalFooter.content) === null || ref1 === void 0 ? void 0 : ref1.content) || [];
    var headerNav = headerGlobal.filter(function(blok) {
        return blok.component === "NavigationWrapper";
    });
    var footerNav = footerGlobal.filter(function(blok) {
        return blok.component === "NavigationWrapper";
    });
    var headerLinks = headerNav.map(function(nav) {
        return getNavigations(nav);
    });
    var footerLinks = footerNav.map(function(nav) {
        return getNavigations(nav);
    });
    return {
        headerLinks: headerLinks,
        footerLinks: footerLinks
    };
}


/***/ }),

/***/ 79426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DynamicComponent; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dynamic.js
var dynamic = __webpack_require__(17953);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/storyblok-react@0.1.2_zpnidt7m3osuk7shl3s4oenomq/node_modules/storyblok-react/lib/sb-editable.js
var sb_editable = __webpack_require__(60598);
;// CONCATENATED MODULE: ./storyblok/components/Page.tsx

//* eslint-disable react/prop-types */
// eslint-disable-next-line import/no-cycle

var Page = function(param) {
    var blok1 = param.blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: blok1.body ? blok1.body.map(function(blok) {
            return(// eslint-disable-next-line no-underscore-dangle
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DynamicComponent, {
                blok: blok
            }, blok._uid));
        }) : null
    });
};
/* harmony default export */ var components_Page = (Page);

;// CONCATENATED MODULE: ./storyblok/components/DynamicComponent.tsx






// Resolved Storyblok Component to local Components
// sorted a-z
var Components = {
    Accordion: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.bind(__webpack_require__, 88653));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(88653)
                ];
            }
        }
    }),
    AddToCartButtons: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9656).then(__webpack_require__.bind(__webpack_require__, 99656));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(99656)
                ];
            }
        }
    }),
    AccordionItem: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6965).then(__webpack_require__.bind(__webpack_require__, 96965));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(96965)
                ];
            }
        }
    }),
    Button: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7107).then(__webpack_require__.bind(__webpack_require__, 27107));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(27107)
                ];
            }
        }
    }),
    Card: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9311).then(__webpack_require__.bind(__webpack_require__, 85821));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(85821)
                ];
            }
        }
    }),
    Carousel: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7060).then(__webpack_require__.bind(__webpack_require__, 67060));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(67060)
                ];
            }
        }
    }),
    CodeBlock: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 4289).then(__webpack_require__.bind(__webpack_require__, 74289));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(74289)
                ];
            }
        }
    }),
    Column: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7581).then(__webpack_require__.bind(__webpack_require__, 57581));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(57581)
                ];
            }
        }
    }),
    CustomFont: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 921).then(__webpack_require__.bind(__webpack_require__, 10921));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(10921)
                ];
            }
        }
    }),
    CustomCode: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8590).then(__webpack_require__.bind(__webpack_require__, 78590));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(78590)
                ];
            }
        }
    }),
    DescriptionList: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 1048).then(__webpack_require__.bind(__webpack_require__, 61048));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(61048)
                ];
            }
        }
    }),
    Grid: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 5657).then(__webpack_require__.bind(__webpack_require__, 15657));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(15657)
                ];
            }
        }
    }),
    GlobalBlock: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9542).then(__webpack_require__.bind(__webpack_require__, 19542));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(19542)
                ];
            }
        }
    }),
    FontLoader: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9635).then(__webpack_require__.bind(__webpack_require__, 69635));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69635)
                ];
            }
        }
    }),
    Heading: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 4117).then(__webpack_require__.bind(__webpack_require__, 74117));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(74117)
                ];
            }
        }
    }),
    Hero: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9314).then(__webpack_require__.bind(__webpack_require__, 19314));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(19314)
                ];
            }
        }
    }),
    HeroCarousel: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 2045).then(__webpack_require__.bind(__webpack_require__, 32045));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(32045)
                ];
            }
        }
    }),
    HorizontalLine: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8028).then(__webpack_require__.bind(__webpack_require__, 68028));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(68028)
                ];
            }
        }
    }),
    HoverImage: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 3498).then(__webpack_require__.bind(__webpack_require__, 33498));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(33498)
                ];
            }
        }
    }),
    HubspotFrame: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9528).then(__webpack_require__.bind(__webpack_require__, 89528));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(89528)
                ];
            }
        }
    }),
    Icon: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 1139).then(__webpack_require__.bind(__webpack_require__, 1139));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1139)
                ];
            }
        }
    }),
    Image: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 2287).then(__webpack_require__.bind(__webpack_require__, 52287));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(52287)
                ];
            }
        }
    }),
    ImageWithText: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9133).then(__webpack_require__.bind(__webpack_require__, 9133));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(9133)
                ];
            }
        }
    }),
    Modal: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 386).then(__webpack_require__.bind(__webpack_require__, 40386));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(40386)
                ];
            }
        }
    }),
    OpeningTimes: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8012).then(__webpack_require__.bind(__webpack_require__, 8012));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(8012)
                ];
            }
        }
    }),
    OpenType: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7066).then(__webpack_require__.bind(__webpack_require__, 67066));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(67066)
                ];
            }
        }
    }),
    Panel: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 1795).then(__webpack_require__.bind(__webpack_require__, 61795));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(61795)
                ];
            }
        }
    }),
    page: components_Page,
    Products: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6045).then(__webpack_require__.bind(__webpack_require__, 6045));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6045)
                ];
            }
        }
    }),
    Spacer: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9307).then(__webpack_require__.bind(__webpack_require__, 69307));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69307)
                ];
            }
        }
    }),
    Table: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8321).then(__webpack_require__.bind(__webpack_require__, 58321));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(58321)
                ];
            }
        }
    }),
    Tabs: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 5862).then(__webpack_require__.bind(__webpack_require__, 65862));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(65862)
                ];
            }
        }
    }),
    Tag: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6183).then(__webpack_require__.bind(__webpack_require__, 56183));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(56183)
                ];
            }
        }
    }),
    Tags: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7722).then(__webpack_require__.bind(__webpack_require__, 47722));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(47722)
                ];
            }
        }
    }),
    Text: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6730).then(__webpack_require__.bind(__webpack_require__, 26730));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(26730)
                ];
            }
        }
    }),
    Theme: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 3300).then(__webpack_require__.bind(__webpack_require__, 23300));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(23300)
                ];
            }
        }
    }),
    Timeline: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7788).then(__webpack_require__.bind(__webpack_require__, 47788));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(47788)
                ];
            }
        }
    }),
    TypefaceHero: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 9547).then(__webpack_require__.bind(__webpack_require__, 39547));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(39547)
                ];
            }
        }
    }),
    TypefaceCards: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 3601).then(__webpack_require__.bind(__webpack_require__, 13601));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(13601)
                ];
            }
        }
    }),
    VariableFont: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 5301).then(__webpack_require__.bind(__webpack_require__, 65301));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(65301)
                ];
            }
        }
    }),
    Video: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8049).then(__webpack_require__.bind(__webpack_require__, 33193));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(33193)
                ];
            }
        }
    }),
    FaqSearch: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6298).then(__webpack_require__.bind(__webpack_require__, 36298));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(36298)
                ];
            }
        }
    }),
    FaqItems: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6553).then(__webpack_require__.bind(__webpack_require__, 6553));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6553)
                ];
            }
        }
    }),
    FaqTopics: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 1277).then(__webpack_require__.bind(__webpack_require__, 71277));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(71277)
                ];
            }
        }
    }),
    SubscriptionForm: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 8883).then(__webpack_require__.bind(__webpack_require__, 68883));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(68883)
                ];
            }
        }
    }),
    SupportHero: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 3250).then(__webpack_require__.bind(__webpack_require__, 63250));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(63250)
                ];
            }
        }
    }),
    VideoHero: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 6808).then(__webpack_require__.bind(__webpack_require__, 16808));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(16808)
                ];
            }
        }
    }),
    VideoHeroControls: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 4964).then(__webpack_require__.bind(__webpack_require__, 94964));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(94964)
                ];
            }
        }
    }),
    SiteTicker: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 7752).then(__webpack_require__.bind(__webpack_require__, 67752));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(67752)
                ];
            }
        }
    }),
    TagsV2: (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 3925).then(__webpack_require__.bind(__webpack_require__, 83925));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(83925)
                ];
            }
        }
    })
};
var DynamicComponent = function(param) {
    var blok = param.blok, styles = param.styles;
    var isPreview = (0,router.useRouter)().isPreview;
    // check if component is defined above
    if (typeof Components[blok.component] !== "undefined") {
        var Component = Components[blok.component];
        // wrap with SbEditable for visual editing
        return isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sb_editable/* default */.Z, {
            content: blok,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                blok: blok,
                styles: styles
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            blok: blok,
            styles: styles
        });
    }
    // fallback if the component doesn't exist
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        children: [
            "The component ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: blok.component
            }),
            " has not been created yet."
        ]
    });
};
DynamicComponent.propTypes = {
    blok: (prop_types_default()).object,
    styles: (prop_types_default()).object || (prop_types_default()).string
};
/* harmony default export */ var components_DynamicComponent = (DynamicComponent);


/***/ }),

/***/ 38841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"siteticker":"SiteTicker_siteticker__SAmQ7","siteticker__inner":"SiteTicker_siteticker__inner__Poniz","siteticker__innerColumn":"SiteTicker_siteticker__innerColumn__auBLD","tickerClose":"SiteTicker_tickerClose__ut87_"};

/***/ }),

/***/ 58152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadbrumbs_breadcrumbs__r0BAd","breadcrumbs__link":"Breadbrumbs_breadcrumbs__link__7Vr9k","name":"Breadbrumbs_name__S7oEp","arrowDesktop":"Breadbrumbs_arrowDesktop__gFL6A","arrowMobile":"Breadbrumbs_arrowMobile__9VCRT","dropdownMenu":"Breadbrumbs_dropdownMenu__YmgVI"};

/***/ }),

/***/ 41450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__k_zpn","hrSmall":"Footer_hrSmall__zYA_v","subscriptionToast":"Footer_subscriptionToast__M_9mO","footer-normal":"Footer_footer-normal__q5Ol_","footer-black":"Footer_footer-black__0Yikn","footer-yellow-grey":"Footer_footer-yellow-grey__24hlY","footer-blue":"Footer_footer-blue__WDwj_","newsletterSubmit":"Footer_newsletterSubmit__zPBU8","footer-charcoal":"Footer_footer-charcoal__VbWV_","footer-grey-light":"Footer_footer-grey-light__X1bIy","footer-grey":"Footer_footer-grey__d6ejo","footer-dark-grey":"Footer_footer-dark-grey__EKfmI","footerLinksContainer":"Footer_footerLinksContainer__0zYxf","footerLink":"Footer_footerLink__MRUwi","socialContainer":"Footer_socialContainer__Brqu6","social":"Footer_social__fZI0A","newsletter":"Footer_newsletter__qmjMJ","newsletterText":"Footer_newsletterText__MszeP","newsletterForm":"Footer_newsletterForm__mIqNg","newsletterFormContainer":"Footer_newsletterFormContainer__ULRyM","newsletterInput":"Footer_newsletterInput__eRsG6","footerSupport":"Footer_footerSupport__YBvfi","mailTo":"Footer_mailTo__y94sh","mobileTagline":"Footer_mobileTagline__po5Mf","subFooter":"Footer_subFooter__i6HSa","subFooterCopy":"Footer_subFooterCopy__XRnb_","subFooterTagline":"Footer_subFooterTagline__0PGeh","subFooterNav":"Footer_subFooterNav__aH7RH","subFooterPrivacy":"Footer_subFooterPrivacy__eSSWJ","subFooterTerms":"Footer_subFooterTerms__cvai4","acceptPolicy":"Footer_acceptPolicy___JUOb","acceptPolicy__text":"Footer_acceptPolicy__text__iPPVm","acceptPolicy__link":"Footer_acceptPolicy__link__JJfnD"};

/***/ }),

/***/ 24962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__NpLkF","submenuContainer":"Menu_submenuContainer__C8qxr","topMenu":"Menu_topMenu__dFgyD","mobileMenuTrigger":"Menu_mobileMenuTrigger__wskl1","mobileMenu":"Menu_mobileMenu__wv65Z","mobileMenu__bottomContent":"Menu_mobileMenu__bottomContent__OgZmN","mobileMenu__bottomMenu":"Menu_mobileMenu__bottomMenu__pF4B_","logoutButton":"Menu_logoutButton__JZG_s","support":"Menu_support__1psym"};

/***/ })

}]);